export enum SolverType {
  COL_3D = 'Col3D',
  MKL = 'MKL',
  PARDISO = 'Pardiso',
}
